<template>
  <g>
    <path
      d="M15.07 11.73a.78.78 0 00-.65.25 5.55 5.55 0 01-3.92 1.72 5.54 5.54 0 01-3.91-1.72.78.78 0 00-.66-.25A4 4 0 002.5 15.7v.49c0 1.78 3.58 3.23 8 3.23s8-1.45 8-3.23v-.5a3.99 3.99 0 00-3.43-3.96M10.5 11.7c2.2 0 4-2.06 4-4.6 0-2.54-1.8-4.6-4-4.6s-4 2.06-4 4.6c0 2.54 1.8 4.6 4 4.6"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ProfileHeaderIcon",
});
</script>
